module.exports = __webpack_public_path__ + "static/media/15UN-Habitat15.ef17c1e9.jpg";